// extracted by mini-css-extract-plugin
export default {"root":"styles_root__P6ibi","container":"styles_container__sQbTC","divider":"styles_divider__u-JWa","list":"styles_list__djZf+","listHeader":"styles_listHeader__q0Ra6"};